import { HelpCenterButton } from "./components/HelpCenterButton"
import { themeOptionFactories } from "./theme"
import { EventsKioskVPage } from "pages/events/index.kiosk-v"
import { EventDetailKioskVPage } from "pages/events/[eventId].kiosk-v"
import { PromotionsKioskVPage } from "pages/promotions/index.kiosk-v"
import { OccupantPromotionKioskVPage } from "pages/promotions/occupant"
import { PromotionDetailKioskVPage } from "pages/promotions/[promotionId].kiosk-v"
import { DiningKioskVPage } from "pages/dining/index.kiosk-v"
import { ServicesKioskVPage } from "pages/services/index.kiosk-v"
import { MapOrdinalKioskVPage } from "pages/maps/[ordinal].kiosk-v"
import { DirectoryKioskVPage } from "./pages/directory/index.kiosk-v"
import { DiningPage } from "pages/dining"
import { AppNavigation as MobileAppNavigation } from "./containers/AppNavigation"
import { Directory } from "pages/directory"
import { Events } from "pages/events"
import { EventDetail } from "pages/events/[eventId]"
import { Promotions } from "pages/promotions"
import { PromotionDetail } from "pages/promotions/[promotionId]"
import { ServicePage } from "pages/services"
import { MapOrdinal } from "pages/maps/[ordinal]"
import { FeatureByCategory } from "pages/maps/[featureType]/[category]"
import { HomePage } from "pages/home"
import { FeatureByCategoryKioskVPage } from "pages/maps/[featureType]/[category].kiosk-v"

export const bitecBuri = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        type: "base",
        index: true,
        element: <HomePage AppNavigation={MobileAppNavigation} />,
      },
      {
        type: "map",
        path: "ordinal/:ordinal",
        element: <MapOrdinal AppNavigation={MobileAppNavigation} />,
      },
      {
        type: "map",
        path: ":featureType/:category",
        element: <FeatureByCategory AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "directory",
        element: <Directory AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "dining",
        element: <DiningPage AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "events",
        element: <Events AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "events/:eventId",
        element: <EventDetail AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "promotions",
        element: <Promotions AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "promotions/:promotionId",
        element: <PromotionDetail AppNavigation={MobileAppNavigation} />,
      },
      {
        path: "services",
        element: <ServicePage AppNavigation={MobileAppNavigation} />,
      },
    ],
    "kiosk-v": [
      {
        path: "directory",
        element: <DirectoryKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        path: "events",
        element: <EventsKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        path: "events/:eventId",
        element: (
          <EventDetailKioskVPage additionalMenu={<HelpCenterButton />} />
        ),
      },
      {
        path: "promotions",
        element: <PromotionsKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        path: "promotions/occupant/:occupantId",
        element: (
          <OccupantPromotionKioskVPage additionalMenu={<HelpCenterButton />} />
        ),
      },
      {
        path: "promotions/:promotionId",
        element: (
          <PromotionDetailKioskVPage additionalMenu={<HelpCenterButton />} />
        ),
      },
      {
        path: "dining",
        element: <DiningKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        path: "services",
        element: <ServicesKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        type: "map",
        path: "ordinal/:ordinal",
        element: <MapOrdinalKioskVPage additionalMenu={<HelpCenterButton />} />,
      },
      {
        type: "map",
        path: ":featureType/:category",
        element: (
          <FeatureByCategoryKioskVPage additionalMenu={<HelpCenterButton />} />
        ),
      },
    ],
    "kiosk-h": [],
  },
}
